import { axiosInstance as axios } from "services";

export const fetchStandardStatements = async () => {
  const { data } = await axios.get("/admin/standardStatementsMaster");
  if (!data.success) throw new Error(data.error || "Failed to fetch standard statements");
  return data;
};

